import React from 'react'
import Container from '../../Container/Container'
import { KeyValueObject } from '../../../atoms/Accordion/types'
import { SlidesProps, SlidesArrayProps } from '../types'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'

const Slide: React.FC<SlidesProps> = withComponentRefresh(
  (props: SlidesProps) => {
    const { model, gtmItems, height } = props
    const dataAttrs: Record<string, string> = {}
    gtmItems?.forEach((gtmItem: KeyValueObject) => {
      if (gtmItem) {
        dataAttrs[gtmItem.key] = gtmItem.value
      }
    })

    const containerConfig = {
      model: {
        ...model,
        ...dataAttrs,
        ...(height ? { height } : { height: 'full' }),
        display: 'flex'
      }
    }

    return <Container {...containerConfig} />
  }
)

export const slidesArray = (props: SlidesArrayProps): React.ReactNode[] => {
  const model = props?.model
  const cqItems = model?.cqItems

  if (!cqItems || Object.keys(cqItems).length === 0) {
    return []
  }

  const { height } = props

  const slides = Object.keys(cqItems).map((cqItemKey) => {
    const {
      ':items': itemsCqItems,
      ':itemsOrder': cqItemsOrder,
      ':type': cqType,
      gtmItems,
      ...itemRest
    } = cqItems[cqItemKey]

    const slideConfig = {
      gtmItems,
      height,
      model: {
        cqItems: itemsCqItems,
        cqItemsOrder,
        cqType,
        ...itemRest
      }
    }

    return <Slide {...slideConfig} key={cqItemKey} />
  })

  return slides
}
